import { Connection, createConnectionFromJson } from '../models/Connection';
import { Repository } from './Repository';

interface CreateConversationParams {
  userId: string;
  text: string;
  currentUserId: string;
}

export class ConnectionRepository extends Repository {
  async createConversation(params: CreateConversationParams): Promise<Connection> {
    const path = 'v1/connections';

    try {
      const response = await Repository.client.post(path, {
        userId: params.userId,
        initialMessage: params.text
      });

      return createConnectionFromJson(response.data.data, {
        currentUserId: params.currentUserId,
        userId: params.userId
      });
    } catch (err) {
      throw err;
    }
  }
}

// Create a singleton instance
export const connectionRepository = new ConnectionRepository();
